// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as DriverRepoConfig from "./DriverRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

var dummyResponse = {
        "driver_info": {
          "msisdn": "3333333333333",
          "uuid": "808080808080",
          "geo_region": "Bangalore",
          "name": "owner1",
          "primary_mobile": "0000000000",
          "secondary_mobile": "0000000000",
          "date_of_joining": "1995-10-10",
          "status":"free",
          "engagement_type": null,
          "login_status": "online",
          "partner_category": "spot",
          "cluster_name": "HSR",
          "is_premium_status": true,
          "app_version": "N/A",
          "current_location": {
            "lat": "23.43",
            "lng": "45.56"
          },
          "latest_location_updated_at": "",
          "last_location_updated_at": "",
          "act_as_helper": {
            "feature_enabled": true,
            "is_active": false
          },
          "helper_labour": {
            "feature_enabled": false,
            "is_active": false
          },
          "serving_outstation": {
            "feature_enabled": true,
            "is_serving": true
          },
          "serving_rental": {
            "feature_enabled": true,
            "is_serving": false
          },
          "is_premium": false,
          "sprinklr_guidance": "Guidance"
        },
        "owner_info": {
          "name": "owner1",
          "mobile": "33435345435345",
          "vehicle_driver": "test",
          "pan": "TESTTESTTEST",
          "bank_name": "test",
          "bank_account_number": "",
          "bank_ifsc": "ABCD00000000"
        },
        "vehicle_info": {
          "vehicle_type": "open",
          "vehicle_number": "KA-51-AB-0351",
          "fuel_category": "cng",
          "service_vehicle_types": [
            "Tata Ace 14ft",
            "Tata Ace 17ft",
            /* // null */
          ],
          "has_nep": null,
        },
        "branding_info": {
          "type":"DOOR",
          "is_approved":true,
          "initial_branding_date":"2020-02-03T13:40:15.233+05:30",
          "last_audit": {
            "start_date": "2020-02-03",
            "end_date": "2020-02-13",
            "status": "SUCCESS"
          },
          "blacklisting": {
            "period":{
              "start": "2020-02-03T13:40:15.237+05:30",
              "end":"2021-02-03T13:40:15.237+05:30"
            },
            "reason":"Partner unionized against Porter Branding"
          }
        }
      };

var dummyPartnerDocumentsResponse = [
        {
        "document_type_name": "Vehicle RC",
        "document_status": "approved"
        },
        {
        "document_type_name": "Driver Licence",
        "document_status": "approved"
        },
        {
        "document_type_name": "Cancelled Cheque or Pass Book",
        "document_status": "uploaded"
        },
        {
        "document_type_name": "Pan Card",
        "document_status": "uploaded"
        },
        {
        "document_type_name": "Vehicle PUC",
        "document_status": "not required"
        },
        {
        "document_type_name": "NOC Document",
        "document_status": "not required"
        },
        {
        "document_type_name": "Vehicle Tax",
        "document_status": "uploaded"
        },
        {
        "document_type_name": "Fitness Certificate",
        "document_status": "not required"
        },
        {
        "document_type_name": "Vehicle Insurance",
        "document_status": "uploaded"
        },
        {
        "document_type_name": "UAE Commercial License",
        "document_status": "not required"
        },
        {
        "document_type_name": "UAE Vehicle Registration Certificate",
        "document_status": "not required"
        },
        {
        "document_type_name": "UAE License",
        "document_status": "not required"
        },
        {
        "document_type_name": "UAE Emirates Card",
        "document_status": "not required"
        },
        {
        "document_type_name": "Owner Aadhar or Voter ID",
        "document_status": "approved"
        },
        {
        "document_type_name": "Driver Aadhar or Voter ID",
        "document_status": "not required"
        },
        {
        "document_type_name": "TDS Declaration",
        "document_status": "submitted"
        }
      ];

var partnerOnboardingResponse = {
      "documents_verification": {
        "enabled": true,
        "documents": [
          {
            "id": 0,
            "name": "string",
            "short_name": "string",
            "is_eligible": true,
            "is_mandatory": true,
            "status": "pending",
            "images": [
              {
                "id": 0,
                "status": "pending",
                "rejection_reason": "string",
                "name": "string",
                "s3_bucket": "string",
                "s3_key": "string"
              }
            ],
            "type": "primary",
            "tip": {
              "description": "string",
              "s3_bucket": "string",
              "s3_key": "string"
            }
          }
        ],
        "status": "completed",
        "instruction": "string"
      },
      "training": {
        "training_steps": [
          {
            "id": 0,
            "title": "string",
            "sub_title": "string",
            "thumbnail": "string",
            "s3_bucket": "string",
            "s3_key": "string",
            "rank": 0,
            "resolution": "string",
            "length": 0,
            "size": 0,
            "lang": "string",
            "type": "video",
            "step_status": "started"
          }
        ],
        "training_status": "trainee_onboarding",
        "training_mode": "online"
      },
      "onboarding_status": "acquired"
      };

var partnerWaitlistResponse = {
        "onboardee_uuid": "abcd_1234",
        "waitlisted_at": 1586265517,
        "waitlist_reason": "onboarding_limit_reached",
        "waitlist_ended_at": null
      };

var dummyFilterDriverResponse = {
        "drivers": [
          {
            "id": 1133,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "OwnerDoc Driver Test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 135
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-02-12T09:29:44.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1132,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "DocTest",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-02-12T09:21:36.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1131,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "training screen",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 135
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-02-17T10:59:09.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1130,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "TrainingAntra Test1",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-20T15:01:38.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1129,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "brand loc",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-02-05T12:24:32.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1128,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "riz1",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-25T07:00:15.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1127,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "riz test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-20T15:17:10.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1126,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "branding refactor",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 135
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2021-02-17T10:25:12.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1125,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Pune 8ft app",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "tata ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2020-12-28T14:47:37.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1124,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "sply 2wh",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "3 Wheeler",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2020-12-18T06:11:18.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1123,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "sply doc",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata 407",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-18T05:20:17.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1122,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "crm test123",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1121,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "crm test123",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {

            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1120,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "crm test123",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "3 Wheeler",
            "app_version": {

            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1119,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "crm test123",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {

            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1116,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "sply lef",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-27T07:33:29.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1115,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "sply leadapp",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {

            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1114,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "custom supply",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {

            },
            "vehicle_stand": {

            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1113,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Akanksha_test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {

            },
            "vehicle_stand": {
              "value": "Porter, 27th Main"
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1112,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Test_Disable",
            "engagement_type": "trip_based",
            "secondary_mobile": "7793817255",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": "HSR Layout, Bengaluru, Karnataka, India"
            },
            "last_updated_at": {
              "value": "2021-01-22T06:32:39.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1111,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "sync sf",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "allocated",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-25T06:41:58.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1107,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "NewTrip Based",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2021-01-19T06:17:57.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1105,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Trip Based",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": "addresss"
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1104,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Tripbased",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {

            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1103,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Trip Based",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata 19ft",
            "app_version": {

            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1102,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Trial",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {

            },
            "vehicle_stand": {
              "value": "BTM Layout, Bengaluru, Karnataka, India"
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1101,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "TripBased Test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {
              "value": "Jayanagar, Bengaluru, Karnataka, India"
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1100,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "3n4 test 3 whlr",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2021-01-21T10:42:11.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1099,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Dwhite tcvs3n4",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Pickup / Dost / Super Ace / 8ft",
            "app_version": {
              "value": 131
            },
            "vehicle_stand": {
              "value": "BTM 2nd Stage"
            },
            "last_updated_at": {
              "value": "2020-10-19T15:29:56.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1098,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Vwhite testvs1",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {
              "value": "BTM Layout 2nd Stage"
            },
            "last_updated_at": {
              "value": "2021-01-27T07:12:07.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1097,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Whitelist A Test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Pickup / Dost / Super Ace / 8ft",
            "app_version": {
              "value": 131
            },
            "vehicle_stand": {
              "value": "BTM 2nd Stage, Bangalore"
            },
            "last_updated_at": {
              "value": "2020-10-06T11:26:30.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1094,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "cashfree1",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": "addresss"
            },
            "last_updated_at": {
              "value": "2021-01-20T04:53:31.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1093,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "partner tst234 NA",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 133
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2020-12-17T10:12:27.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1092,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "TEST test123",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2021-01-18T13:21:02.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1091,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "vaishanavi_partner",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "allocated",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 135
            },
            "vehicle_stand": {
              "value": "Bellandur Junction"
            },
            "last_updated_at": {
              "value": "2021-02-18T15:41:17.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1085,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "button test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2021-01-20T05:23:52.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1081,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "renew",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 127
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2020-10-06T09:16:41.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1080,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "term renew",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 131
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1077,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "delhi 2wh",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 131
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2020-08-28T14:26:54.000Z"
            },
            "shift_timing": {
              "value": "10:0 to 22:0"
            }
          },
          {
            "id": 1074,
            "msisdn": "9999999994007",
            "city": "Bangalore",
            "name": "che testing",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 127
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2020-07-27T15:46:03.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1070,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "shilpa testing",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {
              "value": 134
            },
            "vehicle_stand": {
              "value": ""
            },
            "last_updated_at": {
              "value": "2021-01-21T08:37:52.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1066,
            "msisdn": "6666630303303",
            "city": "Bangalore",
            "name": "branding test",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {

            },
            "vehicle_stand": {

            },
            "last_updated_at": {

            },
            "shift_timing": {

            }
          },
          {
            "id": 1065,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "branding sanity",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "Tata Ace",
            "app_version": {

            },
            "vehicle_stand": {

            },
            "last_updated_at": {

            },
            "shift_timing": {

            }
          },
          {
            "id": 1064,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Jerry",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 122
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2020-06-04T09:58:35.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1063,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Sufi",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 122
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2020-05-28T12:17:18.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1062,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Kuku",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 122
            },
            "vehicle_stand": {

            },
            "last_updated_at": {
              "value": "2020-05-28T11:21:16.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1061,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Momo",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "3 Wheeler Helper",
            "app_version": {
              "value": 129
            },
            "vehicle_stand": {
              "value": "BTM 2nd Stage, Bengaluru, Karnataka, India"
            },
            "last_updated_at": {
              "value": "2020-09-03T08:25:11.000Z"
            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1060,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Ronie",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {

            },
            "vehicle_stand": {

            },
            "last_updated_at": {

            },
            "shift_timing": {

            }
          },
          {
            "id": 1059,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Siri",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {
              "value": 122
            },
            "vehicle_stand": {

            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            }
          },
          {
            "id": 1058,
            "msisdn": "3333333333333",
            "city": "Bangalore",
            "name": "Teja CRM2",
            "engagement_type": "trip_based",
            "secondary_mobile": "0000000000",
            "status": "free",
            "is_available": false,
            "on_leave_today": "no",
            "vehicle_type": "2 Wheeler",
            "app_version": {

            },
            "vehicle_stand": {
              "value": "BTM Layout, Bengaluru, Karnataka, India"
            },
            "last_updated_at": {

            },
            "shift_timing": {
              "value": "8:0 to 20:0"
            },
          }
        ],
        "total_count": 462,
        "offset": {
          "value": "1058"
        }
      };

function fetchDriver(_msisdn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.DriverProfileResponseConverter.execute, result);
                        });
            });
}

function fetchPartnerDocuments(_uuid, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyPartnerDocumentsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.PartnerDocumentResponseConverter.execute, result);
                        });
            });
}

function fetchPartnerWaitlistInfo(_caller_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: partnerWaitlistResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.PartnerWaitlistResponseConverter.execute, result);
                        });
            });
}

function fetchPartnerOnboardingInfo(_caller_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: partnerOnboardingResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.PartnerOnboardingResponseConverter.execute, result);
                        });
            });
}

function fetchFilterDrivers(_request, _offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyFilterDriverResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.FilterDriverResponseConverter.execute, result);
                        });
            });
}

var DriverRepo = {
  dummyResponse: dummyResponse,
  dummyPartnerDocumentsResponse: dummyPartnerDocumentsResponse,
  partnerOnboardingResponse: partnerOnboardingResponse,
  partnerWaitlistResponse: partnerWaitlistResponse,
  dummyFilterDriverResponse: dummyFilterDriverResponse,
  fetchDriver: fetchDriver,
  fetchPartnerDocuments: fetchPartnerDocuments,
  fetchPartnerWaitlistInfo: fetchPartnerWaitlistInfo,
  fetchPartnerOnboardingInfo: fetchPartnerOnboardingInfo,
  fetchFilterDrivers: fetchFilterDrivers
};

export {
  DriverRepo ,
  
}
/* DriverRepoConfig Not a pure module */
